module.exports = __webpack_public_path__ + "media/KikiVR.de97d91a.mp3";